/* eslint-disable react/no-multi-comp */
import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Waypoint } from 'react-waypoint';
import { FormattedMessage, FormattedPlural, intlShape } from 'react-intl';
import { Checkbox, Col, Row } from 'react-bootstrap';
import HearingsSearch from './HearingsSearch';
import LoadSpinner from '../LoadSpinner';
import OverviewMap from '../OverviewMap';
import { labelShape } from '../../types';
import HearingListFilters from './HearingListFilters';
import HearingListItem from './HearingListItem';
import { HEARING_LIST_TABS } from './HearingListTabs';


export const HearingList = ({
                              handleSearch,
                              handleSelectLabels,
                              handleSort,
                              hearings,
                              hearingCount,
                              intl: { formatMessage },
                              isLoading,
                              isMobile,
                              labels,
                              language,
                              searchPhrase,
                              selectedLabels,
                              showOnlyOpen,
                              tab: activeTab,
                              toggleShowOnlyOpen,
                              handleReachBottom,
                              intl,
                              listId,
                            }) => {
  const hearingsToShow = !showOnlyOpen ? hearings : hearings.filter(hearing => !hearing.closed);
  const hasHearings = !isEmpty(hearings);

  const hearingListMap = hearingsToShow ? (
    <Row>
      <Col xs={12}>
        <Helmet title={formatMessage({ id: 'mapView' })} />
        <div className="hearing-list-map map">
          <Checkbox inline readOnly checked={showOnlyOpen} onChange={toggleShowOnlyOpen}
                    style={{ marginBottom: 10 }}>
            <FormattedMessage id="showOnlyOpen" />
          </Checkbox>
          <OverviewMap
            hearings={hearingsToShow}
            style={{ width: '100%', height: isMobile ? '100%' : 600 }}
            enablePopups
          />
        </div>
      </Col>
    </Row>
  ) : null;

  const showLoadMoreHearings = hearings.length < hearingCount;

  return (
    <div>
      <section className="page-section--hearings-search">
        <div className="container">
          <Row>
            <Col md={10} mdPush={1}>
              <HearingsSearch
                handleSearch={handleSearch}
                handleSelectLabels={handleSelectLabels}
                labels={labels}
                language={language}
                searchPhrase={searchPhrase}
                selectedLabels={selectedLabels}
                intl={intl}
              />
            </Col>
          </Row>
        </div>
      </section>
      <section className="page-section page-section--hearings-list" id="hearings-section">
        <div className="container">
          <Row>
            <Col md={10} mdPush={1}>
              {(!isLoading && !hasHearings) && (
                <h2 className="hearing-list__hearing-list-title">
                  <FormattedMessage id="noHearings" />
                </h2>
              )}

              {(hasHearings && activeTab === 'list') && (
                <div>
                  <div className="hearing-list__result-controls">
                    <h2 className="hearing-list__hearing-list-title">
                      {hearingCount}
                      <FormattedPlural
                        value={hearingCount}
                        one={<FormattedMessage id="totalNumHearing" values={{ n: hearingCount }} />}
                        other={<FormattedMessage id="totalNumHearings"
                                                 values={{ n: hearingCount }} />}
                      />
                    </h2>
                    <HearingListFilters handleSort={handleSort} formatMessage={formatMessage} />
                  </div>

                  <div className="hearing-list">
                    <div role="list">
                      {hearings.map(hearing => (
                        <HearingListItem hearing={hearing} key={hearing.id} language={language}
                                         listId={listId} />
                      ))}
                    </div>
                    {isLoading && <LoadSpinner />}
                    {!isLoading && showLoadMoreHearings && 
                    <div className="load-more-container">
                      <button type='button' className='digi-button' onClick={handleReachBottom}><FormattedMessage id="loadMore" /></button>
                    </div>
                    }
                  </div>
                </div>
              )}
            </Col>
          </Row>
          {hasHearings && activeTab === 'map' && !isLoading ? hearingListMap : null}
        </div>
      </section>
    </div>
  );
};

HearingList.propTypes = {
  handleSearch: PropTypes.func,
  handleSelectLabels: PropTypes.func,
  handleSort: PropTypes.func,
  hearings: PropTypes.array,
  hearingCount: PropTypes.number,
  intl: intlShape.isRequired,
  isLoading: PropTypes.bool,
  isMobile: PropTypes.bool,
  labels: PropTypes.arrayOf(labelShape),
  language: PropTypes.string,
  onTabChange: PropTypes.func,
  searchPhrase: PropTypes.string,
  selectedLabels: PropTypes.arrayOf(PropTypes.string),
  showOnlyOpen: PropTypes.bool,
  tab: PropTypes.string,
  toggleShowOnlyOpen: PropTypes.func,
  handleReachBottom: PropTypes.func,
  listId: PropTypes.string,
};

HearingList.defaultProps = {
  tab: HEARING_LIST_TABS.LIST,
  hearingCount: 0,
};

export default HearingList;
